import Grid from '@material-ui/core/Grid'
import * as React from 'react'
import Roles, { IRole, TRoleName } from './roles'

import './style.scss'
interface IProps {
  defaultRole?: TRoleName
  onSelect: (selected: string) => void
}

interface IState {
  selected: TRoleName | null
}

export class RoleSelector extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    const state: IState = { selected: null }
    if (props.defaultRole) {
      state.selected = props.defaultRole
    }
    this.state = state
  }
  _select = (role: IRole) => {
    const { name } = role
    this.setState({ selected: name })
    this.props.onSelect(name)
  }
  renderRole = (role: IRole, i: any) => {
    const selected = this.state.selected === role.name
    return (
      <Grid
        key={i}
        item={true}
        // md={4}
        // sm={4}
        // xs={4}
        className="role"
        onClick={() => this._select(role)}
      >
        <div className={`role-image-container ${selected ? 'selected' : ''}`}>
          {selected && (
            <div className="icon-selected">
              {/* <IconCheckCircle className="icon-selected" />
               */}
              <img
                src={require('../../assets/img/checkmark.svg')}
                className="icon-selected"
              />
            </div>
          )}
          <div className={`role-image ${selected ? 'selected' : ''}`}>
            <img src={role.image} alt={role.title} />
          </div>
        </div>
        <div className={`role-title ${selected ? 'selected' : ''}`}>
          {role.title}
        </div>
      </Grid>
    )
  }
  renderRoles = () => {
    return Roles.map((r, i) => this.renderRole(r, i))
  }
  render() {
    return <div className="roles-container">{this.renderRoles()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/RoleSelector/index.tsx